import React from 'react'
import ContentArea from '../../components/ContentArea'

const AntiInflammatory = () => {
    return (

        <ContentArea>
            <h3>Foods Included in an Anti-Inflammatory Diet: </h3>
            <h4>Preferred Protein Sources</h4>
            <p>• <b>Legumes / beans</b>: lentils, chick peas, adzuki beans, etc. </p>
            <p>• <b>Plant-based products</b>: tempe, tofu, pea protein-based meat substitutes; avoid products containing wheat gluten (ie: seitan) – see sample menu and recipes). </p>
            <p>• <b>Fresh fish</b>: wild fish is preferred; limit to 3 servings per week</p>
            <p>• <b>Protein powder</b>: preferably one of the new hemp-based or pea protein-based powders mixed with a low-sugar milk alternative, like almond milk</p>
            <h4>Vegetables:</h4>
            <p>Our general rule is that if it grows, it’s good for you. </p>
            <p><b>Greens: </b>
            Kale, lettuces, cabbage, mustard greens, spinach Swiss chard, watercress, parsley, bok choy, endive, escarole, Chinese cabbage
            </p>
            <p><b>Other Great Vegetable/Vegetable-like Options:</b> Broccoli, broccoli rabe, cauliflower, brussels sprouts, radishes, celery, cucumber, shitake mushrooms, eggplant, bean Ssprouts, shallots, alfalfa sprouts, asparagus, onions, avocado, string / green beans, scallions, zucchini, turnips, artichoke hearts, aquash, pumpkin, snow pea pods
            </p>
            <p> Fresh sprouts (such as broccoli sprouts, alfalfa sprouts, bean sprouts, etc.) should be eaten several times a week.</p>

            <p>Limit higher carb veggies, such as carrots, yams, and squash to 2 – 3 servings per week.</p>
            <h4>Preferred Grains: </h4>
            <p>Buckwheat (kasha), millet, brown rice, amaranth, barley, rye, quinoa.
            Quinoa is one of our favorite food options as it is more  a seed than a grain, it cooks well, has high nutritional value and is gluten-free.

            </p>
            <p>Wheat and oats should be completely avoided for people who are gluten sensitive. Corn should be avoided entirely for people who have any food sensitivities.</p>

        </ContentArea>
    )
}

export default AntiInflammatory

